// Traduz o erro das rotas /calculator-admin para texto de tela.
//
// O corpo de erro tem QUATRO formatos sem nenhuma chave em comum, e um quinto
// caso que pode nem ser JSON (400 de corpo malformado, que morre no bodyParser
// do Express antes do nosso envelope). A discriminação segue a ordem do
// contrato: `code` -> `property` -> `error` -> sobra o 401 de permissão.
//
// A `message` do upstream vai para a tela em UM caso só: o 400, onde ela é a
// única coisa acionável ("from must not be after to" aponta o filtro errado, e o
// texto por `code` só consegue dizer "revise o período"). Em 404 e 409 ela é o
// oposto — inglês técnico citando o campo de transporte ("backendClientId 42
// already belongs to another client") — e ali a frase em pt-BR sai do `code`.
const MESSAGE_BY_CODE = {
  CALCULATOR_API_BAD_REQUEST:
    "Filtros inválidos. Revise o período e o cliente selecionado.",
  CALCULATOR_API_CLIENT_NOT_FOUND:
    "Cliente não encontrado — a lista pode estar desatualizada. Recarregue.",
  CALCULATOR_API_BACKEND_CLIENT_ID_TAKEN:
    "Este cliente da Jusfy já está vinculado a outro cliente do Calculator API.",
};

export const describeApiError = (error, fallbackMessage) => {
  const status = error?.response?.status;
  const body = error?.response?.data;

  // corpo não-JSON (o 400 de JSON malformado é resposta crua do Express)
  if (!body || typeof body !== "object") return fallbackMessage;

  // 400: a `message` do backend é acionável pelo usuário e é exibida crua
  // (RF-32/CA-25). Sem ela, cai no texto genérico por `code` abaixo.
  if (status === 400 && body.message) return body.message;

  // 404, 409 e 5xx. Code desconhecido cai no fallback junto com os 5xx: todo
  // 5xx aqui é infraestrutura (inclusive o 502 CALCULATOR_API_UNAUTHORIZED, que
  // é chave de serviço errada entre backend e calculator-api) e nunca sessão
  // expirada — nada de logout.
  if ("code" in body) return MESSAGE_BY_CODE[body.code] ?? fallbackMessage;

  // 422: validação nossa, antes de chegar ao calculator-api. `property` vem
  // VAZIO justamente nos casos mais comuns (corpo {}, chave desconhecida, query
  // param desconhecido) — aí a informação útil está toda no `msg`.
  if ("property" in body) {
    return body.property
      ? `Requisição inválida (${body.property}): ${body.msg}`
      : `Requisição inválida: ${body.msg}`;
  }

  // 401 de token: a chave é `error`, não `msg`. Quem desloga é o interceptor do
  // axios; aqui só sobra o texto, caso a tela chegue a renderizar.
  if ("error" in body) return body.error;

  // 401 de permissão (autenticado, mas não é admin) — o único 401 com `msg`
  if ("msg" in body) return body.msg;

  // 404 sem envelope (rota errada, proxy fora do ar)
  if (status === 404) return MESSAGE_BY_CODE.CALCULATOR_API_CLIENT_NOT_FOUND;

  return fallbackMessage;
};
